import React from "react";

// COMPONENTS
import Checkbox from "@components/Checkbox/Checkbox";


export default class CheckboxWithName extends React.PureComponent {

    render() {
        const { props } = this;
        const { onChange } = props;

        return (
            <Checkbox { ...props } onChange={ onChange ? this._onChange : undefined } />
        )
    }

    // Internal methods
    _onChange = (checked) => {
        const { name, onChange } = this.props;
        onChange(name, checked);
    }
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/CheckboxWithName/CheckboxWithName.js